import { Model } from "@vuex-orm/core";

export default class Address extends Model {
  static entity = "addresses";

  static fields() {
    return {
      id: this.attr(null),
      email: this.attr(""),

      notification_id: this.attr(null),
    };
  }
}
